import { render, staticRenderFns } from "./LoyaltyHub.vue?vue&type=template&id=5a2c3a0a"
import script from "./LoyaltyHub.vue?vue&type=script&lang=js"
export * from "./LoyaltyHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports